import {createPiniaStore,} from '@/assets/js/src/pinia'
import {createHead,} from '@unhead/vue/client'
import {createHead as createServerHead,} from '@unhead/vue/server'
import {createRouterInstance,} from '@/assets/js/src/router'
import {createI18nInstance,} from '@/assets/js/src/i18n'
import {createVuetifyInstance,} from '@/assets/js/src/vuetify'
import {setInitializedApp,} from '@/assets/js/src/util/appRef'
import SvgIcon from '@/assets/js/src/components/SvgIcon.vue'
import {Perf,} from "@/assets/js/src/util/performance"
import {TemplateParamsPlugin,} from 'unhead/plugins'

export function setupApp ({state,history,app,}) {
    Perf.start('createApp');

    // create router, store and i18n instances
    const pinia = createPiniaStore({initState:state,})
    const head = import.meta.env.SSR ? createServerHead({
        disableDefaults: true,
        plugins: [TemplateParamsPlugin,]
    }) : createHead({
        plugins: [TemplateParamsPlugin,]
    })
    const router = createRouterInstance({pinia,history,head,app,})
    const i18n = createI18nInstance({pinia,})
    const vuetify = createVuetifyInstance({i18n,pinia,})

    app.component('SvgIcon', SvgIcon)
    app.use(head)
    app.use(vuetify)
    app.use(router)
    app.use(pinia)
    app.config.globalProperties.$isServer = import.meta.env.SSR
    app.config.globalProperties.$i18n = i18n
    app.config.globalProperties.$vuetify = vuetify

    setInitializedApp(app)

    Perf.end('createApp')

    // expose the app, the router and the store.
    return {app, router, i18n, pinia, head,}
}

